<template>
  <div>
    <div
      v-for="(tags, tagType) in groupedTags" 
      :key="tagType"
      class="timeline__item-container"
    >
      <div class="timeline__item timeline__item--hide-timeline flex--grow">
        <i class="fa fa-tag m-t-2 f-s-10" />
        
        <div class="flex--grow">
          <div class="m-l-7 m-b-3">
            <strong>{{ tagType | camelCaseFormat }}</strong>
          </div>
            
          <div class="m-l-7">
            <div
              v-for="(tag, index) in tags"
              :key="index"
              class="generic-args"
            >
              <span class="generic-args__name overflow-ellipsis">
                <TruncatedTextCopy
                  :copy-text="tag.name | camelCaseFormat"
                >
                  {{ tag.name | camelCaseFormat }}
                </TruncatedTextCopy>
              </span>

              <span class="generic-args__value overflow-ellipsis">
                <TruncatedTextCopy
                  :copy-text="tag.value"
                >
                  {{ tag.value }}
                </TruncatedTextCopy>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import messages from '../../../locales';
import sharedMessages from '@/core/locales';

import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';

export default {
  name: 'RtbTags',
  components: {
    TruncatedTextCopy
  },
  props: {
    groupedTags: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>